import React, { useState, useContext } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { useIntl, FormattedMessage } from "react-intl";
import Button from "@ui-components/Button";
import Label from "@ui-components/Label";

import { NotificationsContext } from "@ui-components/Notifications";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";

const ServiceApPricelistUpload = ({ serviceId }) => {
  const intl = useIntl();
  const { push } = useContext(NotificationsContext);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = React.createRef();
  const apiRequest = useCountryAxiosInstance();

  const handleFileInputChange = async (e) => {
    e.preventDefault();
    if (!e.target.files || e.target.files.length === 0) return;
    let file = e.target.files[0];

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await apiRequest.post(
        `/price_analysis/pricelist_update/${serviceId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        }
      );
      if (!response) {
        push({
          type: "error",
          title: intl.formatMessage({ id: "error_uploading" }),
        });
        return null;
      }
      push({
        type: "success",
        title: intl.formatMessage({ id: "success_uploading" }),
      });
    } finally {
      setUploading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };
  return (
    <>
      <div
        className={[
          "flex flex-col gap-3",
          uploading
            ? "pointer-events-none cursor-not-allowed"
            : "cursor-pointer",
        ].join(" ")}
        onClick={() => {
          fileInputRef.current.click();
        }}
      >
        <Label>
          <FormattedMessage id="upload_pricelist" />
        </Label>
        <Button full submitting={uploading}>
          <PlusIcon className="-ml-0.5 w-4" />
          <FormattedMessage id="update" />
        </Button>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept="text/plain,.xpwe"
        onChange={handleFileInputChange}
        hidden
      />
    </>
  );
};

export default ServiceApPricelistUpload;
